<div class="my-3 my-md-5">
    <div class="container-fluid">
    	<div class="col-sm-6 float-left">
	        <h1 class="page-title">City Circle List</h1>
	    </div>
	</div>
</div>    

<div class="container-fluid px-4 pt-4 card">
    <div class="card">
        <div class="tableFixHead" style="overflow: scroll">
        <table class="table table-striped doctorTable">
            <thead>
                <tr>
                    <th>#</th>
                    <th class="w-10">Circle Name</th>
                    <th>Cities</th>
                    <th class="text-center">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let circle of circleCities;let index = index;">
                    <td >{{index+1}}</td>
                    <td>{{circle.leadcircleName}}</td>
                    <td>
                        <div class="citiesshow" *ngFor="let city of circle.allcities;">
                            {{city.cityName}}
                        </div>
                    </td>
                    <td>
                        <button class="btn btn-secondary" routerLink="/update-circle-cities/{{circle.leadcircleName}}/{{circle.id}}">Assigned</button>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
    </div>
</div>

  